import { Button } from 'antd'
import * as Icons from '@ant-design/icons'
import _ from 'lodash'

import { Queries } from 'admin/lib/Api'
import { exportFullCsv } from 'admin/lib/Export/exportFullCsv'

export function CompaniesExport() {
  const companies = Queries.useCompanies()
  return (
    <Button
      disabled={!companies.isFetched}
      onClick={() => exportCompanies(companies.data)}
      icon={<Icons.DownloadOutlined />}
      type="default"
    >
      Export
    </Button>
  )
}

function exportCompanies(companies) {
  const flatCompanies = _.flatMap(companies, flattenCompany)
  exportFullCsv(flatCompanies, [])
}

function flattenCompany(company) {
  if (!company.companyCertificates || company.companyCertificates.length === 0)
    return toExportCompany(company, null)
  return company.companyCertificates.map(c => {
    return toExportCompany(company, c)
  })
}

function toExportCompany(company, certificate) {
  const exportCompany = {
    companyId: company.companyId,
    companyName: company.name,
    companyNumber: company.companyNumber,
    companyAddress: company.address,
    companyResourceURI: company.resourceURI
  }

  return _.merge(exportCompany, toExportCertificate(certificate))
}

function toExportCertificate(certificate) {
  if (certificate == null)
    return {
      certificateId: '',
      certificateNumber: '',
      certificationScheme: '',
      expirationDate: '',
      certificateResourceURI: '',
      validFromDate: ''
    }
  const exportCert = _.omit(certificate, ['createdAtDate', 'resourceURI'])
  exportCert['certificateResourceURI'] = certificate.resourceURI

  return exportCert
}
